import ApiServer from '@/utils/api/ApiServer.js'
import { QuotaInformation } from '../../../model/Quotas'

const paths = (accountId, quotaId) => {
  const path = {
    getAll: 'accounts/quotas',
    create: `accounts/${accountId}/quotas/`,
    update: `accounts/${accountId}/quotas/${quotaId}`
  }
  return path
}

export default {
  async fetchQuotaInformation (context) {
    context.commit('setLoading', true)
    try {
      const url = ApiServer.urlFor(paths(null, null).getAll)
      const response = await ApiServer.get(url)
      const quotaInfo = new QuotaInformation(response.data).aggregateQuotaInformation()
      context.commit('setQuotaInformation', quotaInfo)
    } finally {
      context.commit('setLoading', false)
    }
  },

  async createQuota (_, { quota }) {
    const response = await ApiServer.post(paths(quota.accountId, null).create, quota)
    return response.data
  },

  async updateQuota (_, { quota }) {
    const path = paths(quota.accountId, quota.quotaId).update
    const response = await ApiServer.put(path, quota)
    return response.data
  }
}
